import Model from 'offline/stream/model/base'
import GamesTemplate from 'offline/filter/template/games'

var LIST_FREQUENCY_MONTHLY = 1
var LIST_FREQUENCY_YEARLY = 2

function dateAt(y, m, d, h, i, s) {
	return Math.floor(new Date(y, m, d, h || 0, i || 0, s || 0).getTime() / 1000)
}

function monthStart(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), date.getMonth(), 1)
}

function monthEnd(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59)
}

function yearStart(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), 0, 1)
}

function yearEnd(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), 11, 31, 23, 59, 59)
}

export default Model.extend({
	table: 'list',
	prefix: 'list',
	key: 'list_id',
	fields: {
		list_id: Model.SCHEMA_NUMBER,
		group_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		buddies_id: Model.SCHEMA_NUMBER,
		list_public: Model.SCHEMA_NUMBER,
		list_ready: Model.SCHEMA_NUMBER,
		list_slug: Model.SCHEMA_TEXT,
		list_template: Model.SCHEMA_NUMBER,
		list_date_create: Model.SCHEMA_DATE_CREATE,
		list_date_start: Model.SCHEMA_DATE,
		list_date_update: Model.SCHEMA_DATE,
		list_type: Model.SCHEMA_NUMBER,
		list_frequency: Model.SCHEMA_NUMBER,
		list_ranked: Model.SCHEMA_NUMBER,
		list_name: Model.SCHEMA_TEXT,
		list_description: Model.SCHEMA_TEXT,
		list_filter: Model.SCHEMA_JSON,
		list_columns: Model.SCHEMA_JSON,
		list_count_editions: Model.SCHEMA_NUMBER,
		list_count_progress: Model.SCHEMA_NUMBER
	},
	methods: {
		generate_filter: function(edition, filter) {
			filter = filter || this.get_filter() || {}
			filter = JSON.parse(JSON.stringify(filter))

			if (
				edition &&
				(this.get_frequency() === LIST_FREQUENCY_YEARLY || this.get_frequency() === LIST_FREQUENCY_MONTHLY)
			) {
				var date = edition.get_date()
				var startDate = this.get_frequency() === LIST_FREQUENCY_YEARLY ? yearStart(date) : monthStart(date)
				var endDate = this.get_frequency() === LIST_FREQUENCY_YEARLY ? yearEnd(date) : monthEnd(date)

				filter.played = filter.played || {}
				filter.played.context = {
					from: startDate,
					to: endDate
				}

				var playedKeys = ['first', 'last', 'sometime']
				for (var i = 0; i < playedKeys.length; i++) {
					var key = playedKeys[i]
					filter.played[key] = filter.played[key] || {}

					if (filter.played[key].edition === true) {
						filter.played[key].from = startDate
						filter.played[key].to = endDate
					} else {
						if (filter.played[key].from === true) filter.played[key].from = startDate
						if (filter.played[key].to === true) filter.played[key].to = endDate
					}
				}

				filter.rated = filter.rated || {}
				filter.rated.date = filter.rated.date || {}
				var ratedKeys = ['user', 'group']
				for (var j = 0; j < ratedKeys.length; j++) {
					var ratedKey = ratedKeys[j]
					filter.rated.date[ratedKey] = filter.rated.date[ratedKey] || {}
					if (filter.rated.date[ratedKey].from === true) filter.rated.date[ratedKey].from = startDate
					if (filter.rated.date[ratedKey].to === true) filter.rated.date[ratedKey].to = endDate
				}
			}

			return GamesTemplate.fill(filter)
		},
		to_array: function() {
			return {
				id: this.get_id(),
				slug: this.get_slug(),
				type: this.get_type(),
				frequency: this.get_frequency(),
				public: this.get_public(),
				ranked: this.get_ranked(),
				template: this.get_template(),
				name: this.get_name(),
				description: this.get_description(),
				filter: this.get_filter() || {},
				columns: this.get_columns() || [],
				date: {
					create: this.get_date_create() || 0,
					start: this.get_date_start() || 0,
					update: this.get_date_update() || 0
				},
				count: {
					editions: this.get_count_editions() || 0,
					progress: this.get_count_progress() || 0
				}
			}
		}
	}
})
